import { Component } from 'react';

export type Props<A> = {
	args: A;
	// @ts-expect-error - TS2370 - A rest parameter must be of an array type.
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/react/handler-naming
	op: (...args: A) => any;
};

// eslint-disable-next-line jira/react/no-class-components
class OpTrigger<A extends ReadonlyArray<unknown>> extends Component<Props<A>> {
	static defaultProps = { args: [] };

	componentDidMount() {
		this.props.op(...this.props.args);
	}

	render() {
		return null;
	}
}

export default OpTrigger;
